export type CustomFieldsMapping = Record<string, Record<string, string>>;
export const customFieldsMapping: CustomFieldsMapping =  {
    'booking.engadin.ch': { 'object-type': 'booking' },
    'www.booking.engadin.ch': { 'object-type': 'booking' },
    'maps.engadin.ch': { 'object-type': 'maps' },
    'www.maps.engadin.ch': { 'object-type': 'maps' },
};
